const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: "Title",
        dataIndex: "title",
        render: defaultRender
    },
    {
        title: "Version",
        dataIndex: "version",
        render: defaultRender
    },
    {
        title: "Documents",
        dataIndex: "documents"
    },
    {
        title: "Status",
        dataIndex: "status",
        render: defaultRender
    },
    {
        title: "Created Date",
        dataIndex: "createdDate",
        render: defaultRender
    },
    {
        title: "Actions",
        dataIndex: "actions",
        render: defaultRender
    }
];

export default columns;
